var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"container"},[_c('p',[_vm._v("© 2020 "),_c('a',{attrs:{"href":"https://glyphglyder.com"}},[_vm._v("Glyph Glyder")]),_vm._v(" LLC")])])])
}]

export { render, staticRenderFns }